module.exports = __webpack_public_path__ + "img/mail-icon.ccdd6f56.svg";